<template>
  <div v-if="!isAuthenticated" id="unAuthenticated-app-container">
    <v-app>
      <v-container fluid fill-height class="pa-0">
        <v-layout justify-center align-center>
          <router-view></router-view>
        </v-layout>
      </v-container>
    </v-app>
  </div>

  <div v-else id="authenticated-app-container">
    <v-app>
      <v-toolbar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        color="white"
        app
        fixed
        class="elevation-1 pl-0"
      >
        <v-toolbar-title class="ml-0 pl-2">
          <span id="app-logo" class="hidden-sm-and-down" @click="goToPage('/home')">{{ getUser.orgName }}</span>
        </v-toolbar-title>

        <text-with-label
          v-for="item in infoList"
          :key="item.text"
          :text="item.text"
          :label="item.label"
          dense
        ></text-with-label>

        <v-spacer></v-spacer>

        <v-menu offset-y left>
          <v-btn slot="activator" icon>
            <v-icon>settings</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="(item, index) in adminPages"
              v-if="item.level <= getUser.level"
              :key="index"
              @click="goToPage(`/admin/${item.href}`)"
            >
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile key="test" @click="goToPage('/test')">
              <v-list-tile-title>Environment Test</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-btn flat v-if="getUser">
          {{ getUser.name || getUser.username }}
        </v-btn>
        <v-btn @click="userSignOut()" flat>Sign Out</v-btn>
      </v-toolbar>
      <v-content>
        <v-container fluid fill-height class="pa-0">
          <v-layout justify-center align-center>
            <router-view></router-view>
            <div id="loading-overlay" v-show="getLoading">
              <v-progress-circular
                indeterminate
                color="primary"
                id="loading-indicator"
              ></v-progress-circular>
            </div>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>

  import { mapGetters, mapActions } from 'vuex'
  import TextWithLabel from '@/components/TextWithLabel.vue'
  import common from '@/utils/common'

  export default {
    components: {
      TextWithLabel
    },
    data() {
      return {
        dialog: false,
        drawer: null,
        items: [
          { icon: 'list_alt', text: 'Examinations', href: '/examinations' },
          { icon: 'assignment', text: 'Reports', href: '/reports' },
          { icon: 'style', text: 'Admin', href: '/admin' }
        ],
        adminPages: [
          {
            name: 'Organization',
            href: 'organization-list',
            level: 1
          },
          {
            name: 'Doctors',
            href: 'doctor-list',
            level: 1
          },
          {
            name: 'Employee Types',
            href: 'employeeType-list',
            level: 9
          },
          {
            name: 'Examinations',
            href: 'examination-list',
            level: 1
          },
          {
            name: 'Examination Types',
            href: 'examinationType-list',
            level: 9
          },
          {
            name: 'Landmarks',
            href: 'landmark-list',
            level: 9
          },
          {
            name: 'Inspection Instruments',
            href: 'inspectionInstrument-list',
            level: 1
          },
          {
            name: 'Wash Instruments',
            href: 'washInstrument-list',
            level: 1
          },
          {
            name: 'Antiplatelet',
            href: 'antiplatelet-list',
            level: 9
          },
          {
            name: 'Antispasmodic',
            href: 'antispasmodic-list',
            level: 9
          },
          {
            name: 'Preparation Agents',
            href: 'cleanMed-list',
            level: 9
          },
          {
            name: 'Sedatives',
            href: 'sedative-list',
            level: 9
          },
          {
            name: 'Patients',
            href: 'patient-list',
            level: 1
          },
          {
            name: 'Nurse',
            href: 'technicalStaff-list',
            level: 1
          },
          {
            name: 'Users',
            href: 'user-list',
            level: 9
          },
          {
            name: 'Analytics',
            href: 'analytics',
            level: 1
          }
        ],
        infoList: []
      }
    },

    computed: {
      ...mapGetters([
        'getLoading',
        'getUser'
      ]),
      ...mapGetters('examinations', [
        'getExaminationData',
        'getExaminationTypeList',
        'getPatient'
      ]),

      isAuthenticated () {
        return this.$store.getters.getUser ? true : false
      },
      getExaminationType () {
        return this.getExaminationTypeList.filter(type => type.id === this.getExaminationData.examination.examination_typeID)
      }

    },
    
    methods: {
      ...mapActions([
        'userSignOut'
      ]),

      goToPage (page) {
        this.$router.push(page)
      },
      setExaminationInfo () { // TODO: there is bug here
        const examination = this.getExaminationData.examination
        const patient = this.getPatient
        const age = common.calculageAge(patient.birthday, 'YYYY-MM-DD') 

        this.infoList = [
          { label: 'Examination Type', text: this.getExaminationType[0].examination_type },
          { label: 'Examination Record', text: examination.accNo },
          { label: 'Medical Record', text: patient.no },
          { label: 'Name', text: patient.name },
          { label: 'Age', text: age.toString() },
          { label: 'Gender', text: common.getGender(patient.gender)}
        ]
      }
    },
    beforeUpdate(){

      const hasExamination = this.getExaminationData && this.getExaminationData.examination.id
      const sameExaminationId = this.getExaminationData && (this.getExaminationData.examination.id === parseInt(this.$route.params.examinationID))
      const inExaminationPage = this.$route.path.indexOf('/examinations') == 0
      
      if (hasExamination && inExaminationPage && sameExaminationId) {
        this.setExaminationInfo()
      } else if (!inExaminationPage) {
        this.infoList = []
      }

    }
  }
</script>

<style lang="scss">
  #unAuthenticated-app-container {
    height: 100%;

    .theme--light.application {
      //height: 100%;
    }
  }

  .v-toolbar__content {
    padding-left: 16px;
  }

  /***** TODO *****/
  /***** Make overlay 100% height of the browser and do not allow scrolling *****/
  /***** And make spinner align center *****/
  #loading-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(#e3e3e3, 0.9);
    z-index: 5;
    display: flex;
    padding-top: 200px;
    justify-content: center;
    overflow: hidden;
  }

  .v-toolbar--clipped {
    z-index: 6;
  }

  #app-logo {
    cursor: pointer;
  }

  .v-toolbar__content {
    .text-with-label-component {
      margin-left: 20px;
    }
  }
</style>
